import { IButton } from './Button.types';

import ButtonStyle from './Button.module.scss';

const Button = ({
  className,
  onPress,
  title,
  isLoading,
  disabled,
  type,
  color,
  width,
  borderRadius,
  fontSize,
  height,
  textAlign,
  padding,
  fontWeight,
  maxWidth,
  icon,
  cursor,
  backgroundColor,
  border,
  margin,
  leftIcon,
  minWidth,
  btnTitleClassName,
  rightIconBtnClassName,
  leftIconBtnClassName,
  ...props
}: IButton) => {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      onClick={onPress}
      disabled={isLoading || disabled}
      className={
        color === 'secondary'
          ? `${ButtonStyle.payfisecbtn} ${className}`
          : `${ButtonStyle.payfibtn} ${className}`
      }
      {...props}
      style={{
        width,
        borderRadius,
        fontSize,
        height,
        textAlign,
        padding,
        fontWeight,
        cursor,
        color,
        backgroundColor,
        border,
        maxWidth,
        margin,
        minWidth
      }}>
      {leftIcon && <span className={leftIconBtnClassName || ButtonStyle.leftIcon}>{leftIcon}</span>}
      <span className={btnTitleClassName}>{isLoading ? 'Loading...' : title}</span>
      {icon && <span className={rightIconBtnClassName || ButtonStyle.rightIcon}>{icon}</span>}
    </button>
  );
};

export default Button;
